import { ReactNode } from "react";

/**
 * The head of every page reached from the menu: the menu's own icon in a dark tile, the title,
 * one line saying what the page is for, and the page's actions on the right.
 * The gap above it is the layout's (`pt-6` in layouts/admin): pages add no top padding of their own,
 * so every title sits at the same height under the top bar.
 */
export function PageHeader({
    icon, title, subtitle, actions, className = "",
}: {
    /** The same icon as the page's menu entry (routes.tsx). */
    icon: ReactNode;
    title: ReactNode;
    subtitle?: ReactNode;
    actions?: ReactNode;
    className?: string;
}) {
    return (
        <header className={`mb-6 flex flex-wrap items-center gap-3 font-sans ${className}`}>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-surface-inverse text-ink-inverse [&_svg]:h-5 [&_svg]:w-5">
                {icon}
            </span>
            <div className="min-w-0 flex-1">
                <h1 className="text-2xl font-semibold leading-tight tracking-tight text-ink">{title}</h1>
                {subtitle && <p className="mt-0.5 text-sm text-ink-muted">{subtitle}</p>}
            </div>
            {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
        </header>
    );
}
